<!-- components/Privacy.svelte -->
<script>
  const email="marino@deepbrain.jp"
</script>


<div class="privacy">
  <div class="col-sm-12 col-md-12 col-lg-12 mb-5">
    <h1><strong>日文老師Aoi App聯盟行銷合作方案</strong></h1>
    <br>
    <br>
    <p>
      您好，我們是來自日本的DeepBrain合同会社，團隊成員為台灣人以及日本人。
    </p>
    <p>
      我們近期推出了採用 ChatGPT 技術的「日文口說老師Aoi」App，可與AI進行自由對話以及矯正發音。希望能跟您合作推廣此App！
    </p>
    <p><strong>媒體介紹：</strong></p>
    <ol>
      <li><a href="https://tw.news.yahoo.com/deepbrain-uses-chatgpt-to-create-japanese-speaking-teacher-aoi-which-can-enhance-japanese-speaking-ability-more-efficiently-140326295.html" target="_blank">Yahoo新聞:DeepBrain以ChatGPT打造「日文口說老師Aoi」，更有效率增強日語口說能力</a></li>
    </ol>
    <p><strong>App連結：</strong></p>
    <ul>
      <li><a href="https://apps.apple.com/tw/app/id1639964534" target="_blank">IOS store下載連結</a></li>
      <li><a href="https://play.google.com/store/apps/details?id=com.db.lingotv" target="_blank">Google play下載連結</a></li>
    </ul>
    <p><strong>合作模式：</strong></p>
    <p>關於合作模式，我們目前採取聯盟模式(affiliate marketing)：</p>
    <p>我們會給您一個專屬的合作網址,<strong>每1人透過網址下載App, 您即可拿到20元台幣的抽成</strong></p>
    <p>舉例來說：</p>
    <ol>
      <ul><strong>1千名使用者 => 2萬元台幣</strong></ul>
      <ul><strong>1萬名使用者 => 20萬元台幣</strong></ul>
    </ol>
    <p>
      關於推廣方式，基本上交由您那邊自由發揮，我們不會做過多的干涉，您可以以影片，圖片或是文字的形式進行推廣，除了自己的頻道也可以到各大社群群組po文推廣
      如果您願意與我們合作，請來信告知<a href="mailto: {email}" target="_blank">{email}</a>
    </p>
    <ul>
      <li>您預計推廣的平台，方式以及大概何時開始進行推廣</li>
      <li>如果您需要採集素材，請告訴我們您在App中註冊時所使用的帳號</li>
    </ul>
    <p>我們這邊確認後，會將您的App帳號權限提升到最高，給您專屬合作網址以及網頁即時查詢下載人數，並跟您確認結算金額的匯款方式。</p>
    <p>
      如果您有任何問題，歡迎來信詢問<a href="mailto: {email}" target="_blank">{email}</a>，我們會盡快回覆您。
    </p>
    <p>若您希望當面詢問或是討論，也歡迎跟我們約30分鐘的線上會議。請告訴我們您方便的時間，我們將為您安排。</p>
  </div>
  <div class="col-sm-12 col-md-12 col-lg-12 mb-5">
    <p>以下是其他詳細資訊：</p>
    <p><strong>**聯盟模式(affiliate marketing)**：</strong></p>
    <ul>
      <li>我們會給您一個專屬的合作網址, 只要有人透過網址下載App, 您即可拿到20元台幣的抽成</li>
      <li>我們會提供您一個網頁, 上面會即時更新目前有多少人透過您的專屬的合作網址下載了App, 讓您可以即時查詢並確保資訊公開透明</li>
      <li>我們將會採取月結的方式與您結算金額, 例如8/1~8/31會總結一筆金額, 9/1~9/30會總結一筆金額</li>
      <li>確定合作後，我們會將您的App帳號權限提升到最高, 方便您體驗App以及採集素材</li>
      <li>關於推廣方式，基本上交由您那邊自由發揮, 除了自己的頻道也可以到各大社群群組po文推廣</li>
    </ul>
    <p><strong>關於App：</strong></p>
    <p>Aoi於今年4月上線，目前擁有約1萬名使用者，並在iOS store獲得4.9分，Google Play 5分的好評。</p>
    <p>
      我們自信App不僅能為您的觀眾提供價值，同時由於App導入了ChatGPT能跟使用者自由對話，因此在趣味性以及話題性上也能幫助您吸引到更多的受眾。
    </p>
    <p>「日文口說老師Aoi」的五大特點：</p>
    <ol>
      <li>自由對話：Aoi搭載了ChatGPT並進行了日語優化，能夠在各種情境下與學習者進行角色扮演對話，讓你在真實生活中的日語交流能游刃有餘。</li>
      <li>發音矯正：透過最先進的聲音辨識AI，可以及時判斷並糾正學習者的發音，讓你的日語口音更接近母語者。</li>
      <li>智能提示：當你詞窮時，Aoi能提供3個現在可以說的選項，以及透過翻譯功能打造專屬於自己的對話。</li>
      <li>語法建議：Aoi老師會對你的對話內容給予文法糾正以及建議說法，讓你能夠有效修正自己的口語錯誤。</li>
      <li>豐富課程：Aoi涵蓋了1000+堂主題課程，包含旅行、生活、工作、面試等多樣情境，以滿足各種學習應用需求。</li>
    </ol>
  </div>
</div>